import React from 'react';
import classNames from 'classnames';

const SkeletonFill = ({ isStatic = false }) => (
  <div
    className={classNames('ws-ui-skeleton-fill', {
      'ws-ui-skeleton-fill--static': isStatic,
    })}
  />
);

export default SkeletonFill;
